import React from 'react';
import { MoonshotBox } from './MoonshotBox';
import { MoonshotSteps } from 'app/common/data/campaigns';
import { MoonshotSubmitFunction } from './types';
import styles from './MoonshotPlanSelection.less';
import { Noun, Verb, trackUe } from '@trello/analytics';
import { UpgradePromptPlanSelection } from 'app/src/components/UpgradePrompts/UpgradePromptPlanSelection';
import { Analytics } from '@trello/atlassian-analytics';
import { useFeatureFlag } from '@trello/feature-flag-client';

interface MoonshotPlanSelectionProps {
  onSubmit: MoonshotSubmitFunction;
}

export const MoonshotPlanSelection: React.FC<MoonshotPlanSelectionProps> = ({
  onSubmit,
}) => {
  const sendGASEvent = useFeatureFlag('dataeng.gasv3-event-tracking', false);

  const onContinueWithTracking = () => {
    onSubmit(MoonshotSteps.PAYMENT_FORM);
    trackUe({
      category: Noun.MOONSHOT,
      verb: Verb.SUBMITS,
      directObj: Noun.BUSINESS_CLASS_UPSELL,
    });

    if (sendGASEvent) {
      Analytics.sendTrackEvent({
        action: 'selected',
        actionSubject: 'team',
        actionSubjectId: 'bcTeam',
        source: 'moonshotPlanSelectionScreen',
      });
    }
  };

  const onSkipWithTracking = () => {
    onSubmit(MoonshotSteps.SUCCESS);
    trackUe({
      category: Noun.MOONSHOT,
      verb: Verb.SKIPS,
      directObj: Noun.BUSINESS_CLASS_UPSELL,
    });

    if (sendGASEvent) {
      Analytics.sendTrackEvent({
        action: 'selected',
        actionSubject: 'team',
        actionSubjectId: 'freeTeam',
        source: 'moonshotPlanSelectionScreen',
      });
    }
  };

  return (
    <MoonshotBox className={styles.upperBox}>
      <UpgradePromptPlanSelection
        onContinue={onContinueWithTracking}
        onSkip={onSkipWithTracking}
        showPlanButtons
      />
    </MoonshotBox>
  );
};
